import React from 'react';

import { Wrapper, NoDataIcon, Text } from './styles';

function NoDataTabs() {
  return (
    <Wrapper>
      <NoDataIcon icon="exclamation-circle" color="#bfbfbf" size="4x" />
      <Text>No data available</Text>
    </Wrapper>
  );
}

export default NoDataTabs;
